import { render, staticRenderFns } from "./TagListItem.vue?vue&type=template&id=45f4a346&scoped=true&"
import script from "./TagListItem.vue?vue&type=script&lang=js&"
export * from "./TagListItem.vue?vue&type=script&lang=js&"
import style0 from "./TagListItem.vue?vue&type=style&index=0&id=45f4a346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4a346",
  null
  
)

export default component.exports